export default "__VITE_ASSET__MKWz3JMF__"